(function () {
    'use strict';

    angular
        .module('app.mentionManagementLogDetailed')
        .factory('mentionManagementLogDetailedService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getMentionManagementLogDetailed(mention_management_log_id, loader) {
                    var url_getMentionManagementLogDetailed = $rootScope.apiUrl + 'mention/getMentionManagementLogDetailed?mention_management_log_id=' + mention_management_log_id;
                    return handleRequest(url_getMentionManagementLogDetailed, 'GET', null, loader);
                }

                service.getMentionManagementLogDetailed = getMentionManagementLogDetailed;
                return service;
            }
        ]);
})();
